import React, { FC, useEffect } from 'react';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import {
  Overlay,
  Wrapper,
  RatioBox,
  EmbedVideo,
  CloseButton,
} from './VideoOverlay.styles';

export interface VideoOverlayProps {
  isOpen?: boolean;
  id?: string;
  close?: () => void;
}

const VideoOverlay: FC<VideoOverlayProps> = ({
  id,
  isOpen = false,
  close = () => undefined,
}) => {
  useEffect(() => {
    if (isOpen) {
      disableBodyScroll();
    }
    return () => {
      clearAllBodyScrollLocks();
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <Overlay data-testid="video-overlay">
          <Wrapper>
            <RatioBox>
              <EmbedVideo
                title="product-video"
                id="ytplayer"
                src={`https://www.youtube-nocookie.com/embed/${id}`}
                frameBorder="0"
              />
            </RatioBox>
          </Wrapper>
          <CloseButton onClick={close}>×</CloseButton>
        </Overlay>
      )}
    </>
  );
};

export default VideoOverlay;
